<template>
  <div class="asc-grid-wrapper-header--container">
    <asc-grid-wrapper-title
      class="asc-grid-wrapper-header--title"
      :title="title"
      :tooltip="tooltip"
    ></asc-grid-wrapper-title>
    <div class="asc-grid-wrapper-header-buttons--container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import AscGridWrapperTitle from './AscGridWrapperTitle'

export default {
  name: 'AscGridWrapperHeader',

  components: {
    AscGridWrapperTitle,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
.asc-grid-wrapper-header--container {
  display: flex;
  margin-bottom: 10px;

  & .asc-grid-wrapper-header--title {
    flex: 1;
  }

  & .asc-grid-wrapper-header-buttons--container {
    justify-content: flex-end;
  }
}
</style>
